import React, {useEffect, useRef, useState} from 'react';
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";
import AboutStartSection from "./sections/startSection/AboutStartSection";
import OptimizeActivitiesSection from "./sections/optimizeActivitiesSection/OptimizeActivitiesSection";
import TeamSection from "../main/sections/teamSection/TeamSection";
import CommandSection from "./sections/commandSection/CommandSection";
import TeamIdeasSection from "./sections/teamIdeasSection/TeamIdeasSection";

const AboutUs = () => {
	const [headerMode, setHeaderMode] = useState<'light' | 'dark'>('light');
	const teamSectionRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleScroll = () => {
			if (teamSectionRef.current) {
				const { top } = teamSectionRef.current.getBoundingClientRect();
				const windowHeight = window.innerHeight;

				if (top <= windowHeight / 95 && top > -teamSectionRef.current.offsetHeight) {
					setHeaderMode("dark");
				} else {
					setHeaderMode("light");
				}
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className={`aboutUsSection`}>
			<Header mode={headerMode} />
			<AboutStartSection />
			<OptimizeActivitiesSection />
			<div ref={teamSectionRef}>
				<TeamSection isAboutUs={true} />
				<CommandSection />
				<TeamIdeasSection />
				<FooterSection />
			</div>
		</div>
	);
};

export default AboutUs;